<div class="result-dialog-wrapper">
  <div class="result-dialog">
    <button class="close-btn" (click)="close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>

    <div class="header">{{ header }}</div>

    <img class="emoji" [src]="imageSrc" alt="result emoji" />

    <div class="content">
      <div class="title">{{ title }}</div>
      <div class="score">{{ scoreText }}</div>
      <div class="message">{{ message }}</div>
    </div>

    <div class="actions">
      <button class="action-btn continue-btn" (click)="close()">Continue</button>
      <button class="action-btn share-btn">
        <mat-icon svgIcon="upload" class="white"/>
        Share
      </button>
    </div>
  </div>
</div>

